export const SUBMIT_BRIEF_ERROR = 'Failed to submit brief to the perseus';

const PERSONALITIES_DEFAULT_VALUE = 0;

const PERSONALITIES = {
    CLASSIC: 'classic',
    ACCESSIBLE: 'accessible',
    FUN: 'fun',
    SIMPLE: 'simple',
    ESTABLISHED: 'established'
};

export const DEFAULT_PERSONALITIES_DATA = {
    personalities: {
        [PERSONALITIES.CLASSIC]: PERSONALITIES_DEFAULT_VALUE,
        [PERSONALITIES.ACCESSIBLE]: PERSONALITIES_DEFAULT_VALUE,
        [PERSONALITIES.FUN]: PERSONALITIES_DEFAULT_VALUE,
        [PERSONALITIES.SIMPLE]: PERSONALITIES_DEFAULT_VALUE,
        [PERSONALITIES.ESTABLISHED]: PERSONALITIES_DEFAULT_VALUE
    }
};
